import { ChangeEvent, FC, InputHTMLAttributes } from "react";

import { Control, Controller } from "react-hook-form";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: boolean;
  iconSrc?: string;
  align?: string;
  parentClassName?: string;
  control?: Control;
  inputmode?:string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const CommonInput: FC<IProps> = ({
  control,
  name,
  value,
  onChange,
  ...props
}) => {

  return (
    <Controller
      render={({ field }) => (
        <input
          {...field}
          {...props}
          onChange={(e) => {
            field.onChange(e);
            if (onChange) {
              onChange(e);
            }
          }}
        />
      )}
      name={name as string}
      defaultValue={value || ""}
      // control={control}
      control={control ? control : undefined}
    />
  );
};

export default CommonInput;
